// extracted by mini-css-extract-plugin
module.exports = {"circle":"VetEmailValidation_circle__18QyQ","success":"VetEmailValidation_success__2DKdR","error":"VetEmailValidation_error__3Yo6t"};